import React, { useEffect, useState } from 'react';

import ConditionalRenderer from './components/conditional-renderer.tsx';
import { getCookieValue, setCookie } from './utils/cookie.utils.ts';

import FloatingWidgetButton from './components/floating-widget-button.tsx';
import EmailCountButton from './components/email-count-button.tsx';
import FloatingWidgetLoginButton from './components/floating-widget-login-button.tsx';

interface AppProps {
  clientId?: string;
  leadType?: number;
  buttonText?: string;
  emailNotification?: string;
  buttonPosition?: string;
  successUrl?: string;
}

const App: React.FC<AppProps> = (props) => {
  const [userAuthenticated, setUserAuthenticated] = useState(false);

  const phoneEmailJWTCookie = getCookieValue('ph_email_jwt');
  const url = new URL(location.href);
  const accessToken = url.searchParams.get("access_token");
  const originUrl = window.location.href;

  const clientId   = props.clientId ?? '';
  const buttonText = props.buttonText ?? 'Sign in with Phone';
  const successUrl = props.successUrl ?? '';

  useEffect(() => {
    const cookie = (document.cookie.match(/ph_email_jwt\s*=\s*([^;]+)/) || [, null])[1];
    setUserAuthenticated(cookie !== null);
  }, []);


  if ((!phoneEmailJWTCookie) && (!accessToken)) { setCookie('ph_email_origin_url', url.origin); }
  if ((!phoneEmailJWTCookie) && (accessToken)) {
    const urlWithoutQuery = originUrl.split('?')[0];
    const redirectURL = successUrl ? `${successUrl}?access_token=${accessToken}&origin_url=${urlWithoutQuery}` : urlWithoutQuery;

    setCookie('ph_email_jwt', url.searchParams.get("phtoken") ?? '');
    window.location.href = redirectURL;
  }

  return (
    <React.Fragment>
      <ConditionalRenderer condition={(userAuthenticated === false)}>
        <FloatingWidgetLoginButton
          clientId={clientId}
          buttonText={buttonText}
        ></FloatingWidgetLoginButton>
      </ConditionalRenderer>
      <ConditionalRenderer condition={(userAuthenticated === true)}>
        <EmailCountButton></EmailCountButton>
        <FloatingWidgetButton></FloatingWidgetButton>
      </ConditionalRenderer>
    </React.Fragment>
  );
};

export default App;
